var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#97B1F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_391_462",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_391_462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1 33.25C17.15 32.3333 16.396 31.254 15.838 30.012C15.2793 28.7707 15 27.4333 15 26C15 24.6167 15.2627 23.3167 15.788 22.1C16.3127 20.8833 17.025 19.825 17.925 18.925C18.825 18.025 19.8833 17.3123 21.1 16.787C22.3167 16.2623 23.6167 16 25 16C26.3833 16 27.6833 16.2623 28.9 16.787C30.1167 17.3123 31.175 18.025 32.075 18.925C32.975 19.825 33.6873 20.8833 34.212 22.1C34.7373 23.3167 35 24.6167 35 26C35 27.4333 34.721 28.775 34.163 30.025C33.6043 31.275 32.85 32.35 31.9 33.25L30.5 31.85C31.2667 31.1167 31.875 30.246 32.325 29.238C32.775 28.2293 33 27.15 33 26C33 23.7667 32.225 21.875 30.675 20.325C29.125 18.775 27.2333 18 25 18C22.7667 18 20.875 18.775 19.325 20.325C17.775 21.875 17 23.7667 17 26C17 27.15 17.225 28.225 17.675 29.225C18.125 30.225 18.7417 31.0917 19.525 31.825L18.1 33.25ZM20.925 30.425C20.3417 29.875 19.875 29.221 19.525 28.463C19.175 27.7043 19 26.8833 19 26C19 24.3333 19.5833 22.9167 20.75 21.75C21.9167 20.5833 23.3333 20 25 20C26.6667 20 28.0833 20.5833 29.25 21.75C30.4167 22.9167 31 24.3333 31 26C31 26.8833 30.825 27.7083 30.475 28.475C30.125 29.2417 29.6583 29.8917 29.075 30.425L27.65 29C28.0667 28.6167 28.3957 28.1667 28.637 27.65C28.879 27.1333 29 26.5833 29 26C29 24.9 28.6083 23.9583 27.825 23.175C27.0417 22.3917 26.1 22 25 22C23.9 22 22.9583 22.3917 22.175 23.175C21.3917 23.9583 21 24.9 21 26C21 26.6 21.121 27.154 21.363 27.662C21.6043 28.1707 21.9333 28.6167 22.35 29L20.925 30.425ZM25 28C24.45 28 23.9793 27.804 23.588 27.412C23.196 27.0207 23 26.55 23 26C23 25.45 23.196 24.979 23.588 24.587C23.9793 24.1957 24.45 24 25 24C25.55 24 26.021 24.1957 26.413 24.587C26.8043 24.979 27 25.45 27 26C27 26.55 26.8043 27.0207 26.413 27.412C26.021 27.804 25.55 28 25 28Z",
    fill: "#97B1F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.4c5db8f2806b3c84aa74b2ddd1ea6911.svg";
export { ForwardRef as ReactComponent };